import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight, X } from "lucide-react";
import { useLang } from "../context/LangContext";

const HIDDEN_ROUTES = ["/contacto", "/admin/login", "/admin"];
const SCROLL_THRESHOLD = 600;
const DISMISS_KEY = "convergen.floating-cta.dismissed";

export default function FloatingCTA() {
  const { t } = useLang();
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(() =>
    typeof window !== "undefined" && sessionStorage.getItem(DISMISS_KEY) === "1"
  );

  const hidden = HIDDEN_ROUTES.some((p) => pathname.startsWith(p));

  useEffect(() => {
    if (hidden || dismissed) {
      setVisible(false);
      return;
    }
    const onScroll = () => setVisible(window.scrollY > SCROLL_THRESHOLD);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [hidden, dismissed, pathname]);

  if (hidden || dismissed || !visible) return null;

  const onDismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, "1");
    setDismissed(true);
  };

  return (
    <div
      data-testid="floating-cta"
      className="fixed bottom-24 right-6 z-30 animate-fade-up"
    >
      <div className="relative flex items-stretch shadow-[0_20px_50px_-20px_rgba(8,24,58,0.45)] scan-stripe">
        <Link
          to="/contacto"
          data-testid="floating-cta-link"
          className="group bg-ink hover:bg-cerulean text-white px-5 py-4 flex items-center gap-3 transition-colors"
        >
          <span className="live-dot" aria-hidden />
          <span className="text-[10px] font-mono tracking-[0.22em] uppercase text-cerulean group-hover:text-white">30 MIN</span>
          <span className="text-sm font-medium tracking-wide">{t.nav.cta}</span>
          <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" strokeWidth={1.5} />
        </Link>
        <button
          onClick={onDismiss}
          data-testid="floating-cta-dismiss"
          aria-label="Cerrar"
          className="bg-ink hover:bg-cerulean text-white/70 hover:text-white px-3 border-l border-white/15 transition-colors"
        >
          <X className="w-4 h-4" strokeWidth={1.5} />
        </button>
      </div>
    </div>
  );
}
